
import { Component, Vue } from 'vue-property-decorator';
import BaseHeader from '@/components/BaseHeader.vue';
import { SalesQuote } from '@/api';
import OrderItemList from '@/components/orders/OrderItemList.vue';
import NewClaimFooterTotals from '@/components/claims/new-claim/NewClaimFooterTotals.vue';

@Component({
  components: {
    NewClaimFooterTotals,
    OrderItemList,
    BaseHeader,
  },
})
export default class NewClaimOverviewProducts extends Vue {
  get agreement(): SalesQuote | undefined {
    return this.$store.getters['claim/agreement'];
  }

  get claim(): any {
    return this.$store.state.claim.claimData;
  }
}
